import { StandardEvents } from '@shopify/events';

function measure(eventName, data, options) {
  try {
    if (typeof window.oaiq !== 'function') return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var eventOptions = Object.assign({}, options || {}, {
      opt_out: Boolean(privacy && !privacy.saleOfDataAllowed()),
    });
    window.oaiq('measure', eventName, data, eventOptions);
  } catch {
    // Measurement must never interrupt the storefront journey.
  }
}

function minorUnits(amount, currency) {
  var value = Number(amount);
  if (!Number.isFinite(value) || !currency) return null;

  try {
    var digits = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currency,
    }).resolvedOptions().maximumFractionDigits;
    return Math.round(value * Math.pow(10, digits));
  } catch {
    return Math.round(value * 100);
  }
}

function resourceId(value) {
  var id = String(value || '');
  return id.split('/').pop() || id;
}

document.addEventListener(StandardEvents.pageView, function onPageView(event) {
  var page = event.page || {};
  var path = '';
  try {
    path = new URL(page.url || window.location.href).pathname;
  } catch {
    path = window.location.pathname;
  }

  measure('page_viewed', {
    type: 'contents',
    contents: [{
      id: path || '/',
      name: page.title || document.title,
      content_type: 'page',
    }],
  });
});

document.addEventListener(StandardEvents.productView, function onProductView(event) {
  var product = event.product;
  var variant = product && product.selectedVariant;
  if (!product) return;

  var currency = variant && variant.price && variant.price.currencyCode;
  var amount = variant && minorUnits(variant.price.amount, currency);
  var content = {
    id: resourceId((variant && variant.id) || product.id),
    name: product.title,
    content_type: 'product',
  };
  var data = { type: 'contents', contents: [content] };

  if (amount !== null && currency) {
    data.amount = amount;
    data.currency = currency;
    content.amount = amount;
    content.currency = currency;
  }

  measure('contents_viewed', data);
});

document.addEventListener(StandardEvents.cartLinesUpdate, async function onCartLinesUpdate(event) {
  if (event.action !== 'add' || !Array.isArray(event.lines)) return;

  try {
    var result = await event.promise;
    if (!result || !result.cart || result.detail?.didError) return;

    var contents = event.lines.map(function toContent(line) {
      return {
        id: resourceId(line.merchandiseId),
        content_type: 'product',
        quantity: Number(line.quantity) || 1,
      };
    });
    if (contents.length) measure('items_added', { type: 'contents', contents: contents });
  } catch {
    // Failed cart operations are not conversions.
  }
});
